import React from 'react';
import { ITableViewContext } from 'framework/table/ITableViewContext';
import { ICustomerAccountLine } from 'gen/ApiClient';
import { SelectableColumn } from '../SelectableColumn';

interface IViewContext extends ITableViewContext<SelectableColumn, ICustomerAccountLine> {}

export const ViewContext = React.createContext<IViewContext>(undefined as any);
